import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { ConfirmHost } from "./components/ConfirmDialog";
import { reloadOnce } from "./lib/reload";
import { setUnauthorizedHandler } from "./lib/api";
import { ME_KEY, markSessionExpired } from "./lib/auth";
import "@fontsource-variable/inter";
import "./styles.css";

// Yeni sürüm yayına girdiyse eski sürümün dosyaları bulunamaz: bir kez yenilenir.
window.addEventListener("vite:preloadError", (e) => {
  if (reloadOnce()) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

// Oturum dolmuşsa (başka sekmede çıkış, süre bitti, oturum kapatıldı) girişe dönülür; giriş sonrası aynı sayfa açılır.
setUnauthorizedHandler(() => {
  if (!queryClient.getQueryData(ME_KEY)) return;
  markSessionExpired();
  queryClient.setQueryData(ME_KEY, null);
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ConfirmHost />
    </QueryClientProvider>
  </StrictMode>,
);
